import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SelectInput from '@/components/forms/SelectInput';
import { useStore } from '@/components/store/Store';
import { BlockPath } from '../../CurrentBlockProvider';
import { PageListViewType, PageListLayout } from '../../../../declarations/models/blocks/PageListBlocks';
import { OutlinedContainer } from '../../../../components/OutlinedContainer';
import CheckboxInput from '../../../../components/forms/CheckboxInput';

export const PageListDisplayOptions: FC<{
  blockPath: BlockPath;
  viewType: PageListViewType;
  layout?: PageListLayout;
}> = ({ blockPath, viewType, layout }) => {
  const { t } = useTranslation('components');
  const {
    state: { currentUser },
  } = useStore();
  const mobileGridOptions = ['auto', 'col-1', 'horizontal'];
  const mobileListOptions = ['auto', 'card'];

  return (
    <>
      <OutlinedContainer
        label={`${t('PageListManualBlock.DisplayInputs.Label')}:`}
        fullWidth
        wrap
        sx={{
          backgroundColor: '#fff',
          justifyContent: 'flex-start!important',
          flexFlow: 'row',
          flexWrap: 'wrap',
        }}>
        {viewType !== PageListViewType.SIMPLE && (
          <CheckboxInput
            fullWidth={false}
            path={`${blockPath}.displayInsertTitle`}
            label={t('PageListManualBlock.DisplayInputs.displayInsertTitle')}
          />
        )}

        <CheckboxInput
          fullWidth={false}
          path={`${blockPath}.displayDescription`}
          label={t('PageListManualBlock.DisplayInputs.displayDescription')}
        />

        {viewType !== PageListViewType.SIMPLE && (
          <>
            <CheckboxInput
              fullWidth={false}
              path={`${blockPath}.displayCategory`}
              label={t('PageListManualBlock.DisplayInputs.displayCategory')}
            />
            <CheckboxInput
              fullWidth={false}
              path={`${blockPath}.displayPublishedDate`}
              label={t('PageListManualBlock.DisplayInputs.displayPublishedDate')}
            />
            <CheckboxInput
              fullWidth={false}
              path={`${blockPath}.displayLocation`}
              label={t('PageListManualBlock.DisplayInputs.displayLocation')}
            />
            <CheckboxInput
              fullWidth={false}
              path={`${blockPath}.displayMuseum`}
              label={t('PageListManualBlock.DisplayInputs.displayMuseum')}
            />
          </>
        )}
      </OutlinedContainer>
      {viewType !== PageListViewType.LIST && (
        <OutlinedContainer
          label={`${t('PageListAutoBlock.Adjustments')}:`}
          fullWidth
          sx={{
            backgroundColor: '#fff',
            flexWrap: 'wrap',
            flexFlow: 'row',
          }}>
          {viewType === PageListViewType.GRID && (
            <CheckboxInput path={`${blockPath}.highlightAll`} label={t(`PageListAutoBlock.Highlight`)} />
          )}

          <CheckboxInput path={`${blockPath}.grid33`} label={t(`PageListAutoBlock.ThreeCols`)} />
          <SelectInput
            hideNoSelectionOption
            defaultValue='auto'
            options={mobileGridOptions}
            getOptionKey={(o) => `mobileGrid-${o}`}
            getOptionLabel={(o) => t(`CardModuleViewTypeSelector.CardModuleViewTypeVariant.${o}`)}
            path={`${blockPath}.gridMobileBehaviour`}
            label={t('CardModuleBlock.GridMobileBehaviourLabel')}
          />

          {/* isSuperAdmin && viewType === PageListViewType.GRID && layout === PageListLayout.TEXT_ON_IMAGE && (
            <div className='superadmin' style={{ backgroundColor: '#fbe6ff', padding: '1em', width: '100%' }}>
              <CheckboxInput path={`${blockPath}.textlines`} label={t(`PageListAutoBlock.Textlines`)} />
            </div>
          ) */}

          {/* <CheckboxInput path={`${blockPath}.removeLeftPadding`} label={t(`PageListAutoBlock.RemoveLeftPadding`)} /> */}
        </OutlinedContainer>
      )}

      {viewType === PageListViewType.LIST && (
        <OutlinedContainer
          p={2}
          fullWidth
          sx={{
            backgroundColor: '#fff',
          }}>
          <SelectInput
            hideNoSelectionOption
            defaultValue='auto'
            options={mobileListOptions}
            getOptionKey={(o) => `mobileGrid-${o}`}
            getOptionLabel={(o) => t(`CardModuleViewTypeSelector.CardModuleViewTypeVariant.${o}`)}
            path={`${blockPath}.gridMobileBehaviour`}
            label={t('CardModuleBlock.ListMobileBehaviourLabel')}
          />

          {/* <CheckboxInput path={`${blockPath}.removeLeftPadding`} label={t(`PageListAutoBlock.RemoveLeftPadding`)} /> */}
        </OutlinedContainer>
      )}
    </>
  );
};

export default PageListDisplayOptions;
